'use client'
import type { RichTextFieldClientProps } from 'payload'
import type React from 'react'

export const RichTextField: React.FC<RichTextFieldClientProps> = () => {
  return null
}
